import { ApolloLink } from '@apollo/client';
import { onError } from '@apollo/client/link/error';
import { context, SpanKind, SpanStatusCode, trace } from '@opentelemetry/api';
const traceClientOperation = ({ clientName, appVersion, attributes }) => {
    return new ApolloLink((operation, forward) => {
        const spanContext = context.active();
        const tracer = trace.getTracer(clientName, appVersion);
        const { operationName, getContext: getApolloContext, setContext: setApolloContext } = operation;
        const span = tracer.startSpan(operationName, {
            startTime: getApolloContext().start,
            attributes: {
                'workflow.name': operationName,
                'app.name': clientName,
                ...attributes,
            },
            kind: SpanKind.CLIENT,
        }, spanContext);
        setApolloContext({ span });
        return forward(operation).map((d) => {
            if (!span.isRecording()) {
                return d;
            }
            span.end();
            return d;
        });
    });
};
const traceApolloError = onError(({ graphQLErrors, networkError, operation }) => {
    const { getContext } = operation;
    const span = getContext().span;
    if (!span.isRecording()) {
        return;
    }
    span.setStatus({ code: SpanStatusCode.ERROR });
    if (graphQLErrors) {
        if (Array.isArray(graphQLErrors)) {
            graphQLErrors.forEach(({ message, locations, path, stack }) => {
                span.recordException({
                    message: `[GraphQLError]: Message: ${message}, Location: ${JSON.stringify(locations) || ''}, Path: ${path}`,
                    stack,
                });
            });
        }
    }
    if (networkError) {
        span.recordException({
            message: `[NetworkError]: ${networkError}`,
        });
    }
    span.end();
});
export { traceClientOperation, traceApolloError };
//# sourceMappingURL=index.js.map